import { StorageController } from './controller/storage-controller';
import { StorageEngine } from './types/storage-engine.enum';

export { StorageController } from './controller/storage-controller';
export { StorageEngine } from './types/storage-engine.enum';
export type {
	AsyncStorageEngine,
	SyncStorageEngine
} from './types/storage-engine.interface';
export type { StorageApi } from './types/storage-types';

export const storage = new StorageController(StorageEngine.Local);
